<!-- The date-window pill: the picker variant per the active tab's
     granularity (app-crumb-date-picker — also used in the page breadcrumb's
     date crumb). The pill is ONE click target: a click anywhere in it —
     including the calendar icon — focuses the input, which shows the
     overlay. -->
<!-- The date-window pill: the picker variant per the active tab's
     granularity. The pill carries the THEME's button classes
     (.p-button.p-button-outlined) so its box inherits the exact same
     style as the row's outlined buttons (Today / < > — border, fill,
     radius, hover tokens all from the button cascade, Ray). -->
<span class="crumb-date-pill p-button p-button-outlined" (click)="openPicker($event)">
    <i class="pi pi-calendar crumb-date-icon" aria-hidden="true"></i>

    <!-- day/dispatch: a single date -->
    <p-calendar
        #cal
        *ngIf="pickerKind === 'single'"
        class="crumb-date-picker"
        [(ngModel)]="dayDate"
        dateFormat="D MM d, yy"
        [showIcon]="false"
        [readonlyInput]="true"
        inputStyleClass="crumb-date-input"
        [appHighlightDates]="highlights()"
        panelStyleClass="schedules-datepicker-panel"
        ariaLabel="Schedule day"
        appendTo="body"
        (onShow)="onPanelShow()"
        (onMonthChange)="onPanelMonthChange($event)"
    />
    <!-- week: one click on a date selects the whole next 7 days (Ray) —
         a second, distinct click then narrows to an explicit custom span,
         so this overlay STAYS OPEN after the first pick (CodeRabbit) and
         clears the pending pick when the overlay closes. -->
    <p-calendar
        #cal
        #weekCal
        *ngIf="pickerKind === 'week'"
        class="crumb-date-picker"
        [(ngModel)]="rangeDates"
        selectionMode="range"
        dateFormat="D MM d, yy"
        [hideOnDateTimeSelect]="false"
        [showIcon]="false"
        [readonlyInput]="true"
        inputStyleClass="crumb-date-input"
        [appHighlightDates]="highlights()"
        panelStyleClass="schedules-datepicker-panel"
        ariaLabel="Schedule week"
        appendTo="body"
        (onShow)="onPanelShow()"
        (onMonthChange)="onPanelMonthChange($event)"
        (onClose)="weekPending = null"
    />
    <!-- month: pick the month, not a date (Ray) -->
    <p-calendar
        #cal
        *ngIf="pickerKind === 'month'"
        class="crumb-date-picker"
        [(ngModel)]="monthDate"
        view="month"
        dateFormat="MM yy"
        [showIcon]="false"
        [readonlyInput]="true"
        inputStyleClass="crumb-date-input"
        panelStyleClass="schedules-datepicker-panel crumb-month-picker-panel"
        ariaLabel="Schedule month"
        appendTo="body"
    />
    <!-- map / ops-readiness: start + end over two clicks -->
    <p-calendar
        #cal
        *ngIf="pickerKind === 'range'"
        class="crumb-date-picker"
        [(ngModel)]="rangeDates"
        selectionMode="range"
        dateFormat="D MM d, yy"
        [hideOnDateTimeSelect]="true"
        [showIcon]="false"
        [readonlyInput]="true"
        inputStyleClass="crumb-date-input"
        [appHighlightDates]="highlights()"
        panelStyleClass="schedules-datepicker-panel"
        ariaLabel="Schedule date range"
        appendTo="body"
        (onShow)="onPanelShow()"
        (onMonthChange)="onPanelMonthChange($event)"
    />
</span>